export default __webpack_public_path__ + "static/media/M04.dd931581.mp4";